<template>
    <div class="o-newsItem u-w100 u-py20 u-overflowYAuto">
        <div class="o-newsItem__inner u-container u-overflowHidden">
            <img class="o-newsItem__img u-cover u-br u-mb20 u-w100" v-if="article.thumbnail" :src="article.thumbnail" />
            <h1 class="o-newsItem__title h3" v-if="article.title">{{ article.title }}</h1>
            <div class="o-newsItem__date u-colorSecondary u-fw500 u-fs14 u-mb10" v-if="article.date">{{ article.date }}</div>
            <div v-html="article.content"></div>
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted, inject } from 'vue';
import api from '../services/api';

const currentId = inject('currentId');
const article = ref({});

const fetchNewsItem = async () => {
    try {
        const response = await api.get(`/news/${currentId.value}`);

        if (response.status === 200 && response.data.length !== 0) {
            article.value = response.data;
        }
        
    } catch (error) {
        console.error('Error fetching news item:', error);
    }
};

onMounted(async () => {
    fetchNewsItem();
});
</script>